import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  code: string;
}

const MilestoneStatusBadge: React.FC<Props> = ({ code }) => {
  const { t } = useTranslation();

  let status;
  switch (code) {
    case 'NOT STARTED':
      status = 'notCompleted';
      break;
    case 'COMPLETED':
      status = 'completed';
      break;
    default:
      status = 'notPresent';
      break;
  }

  return (
    <div className={`badge-base milestonestatus ${status}`}>
      <div className="badge-text">
        <span>{t(status)}</span>
      </div>
    </div>
  );
};

export default React.memo(MilestoneStatusBadge);
